/* Copyright (c) 2017 Backpack Health LLC */


import { types as localeActionTypes } from 'redux/actions/locale';
import { types as userActionTypes } from 'redux/actions/user';

const initialState = {
  languageMessages: {},
  clientLocales: [],
  defaultClientLocale: 'en',
};

export function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case userActionTypes.SET_PREFERRED_LANGUAGE:
    case localeActionTypes.ADD_LOCALE:
      return _.assign({}, state, {
        languageMessages: _.assign({}, state.languageMessages, {
          [action.payload.languageCode]: action.payload.languageMessages,
        }),
      });
    case localeActionTypes.SET_CLIENT_LOCALES:
    case localeActionTypes.SET_DEFAULT_CLIENT_LOCALE:
      return _.assign({}, state, action.payload);
    default:
      return state;
  }
}

const selectors = {
  getMessages: (state, languageCode) => state.locale.languageMessages[languageCode] || {},
  getDefaultClientLocale: state => state.locale.defaultClientLocale,
  getClientLocales: state => state.locale.clientLocales,
};

export default selectors;
